<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $t("seatlayout") }}
      </div>
      <router-link class="btn-blue" to="/cinema-manager/seat-layout"
        >{{ $t("seatlayout") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <p style="font-size: 20px">{{ screenName }}</p>
      <div class="row"></div>
      <div class="col-12 mb-4 pt-2">
        <div class="row">
          <div class="col-3" v-if="screenID == 0">
            <b-dropdown
              :text="dropDowns.cinemaDropdown.cinemaSelected.cine_name"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                v-for="(cinema, cinemaIndex) in dropDowns.cinemaDropdown
                  .cinemas"
                href="#"
                :key="cinemaIndex"
                v-on:click="
                  dropDowns.cinemaDropdown.cinemaSelected = cinema;
                  getScreens();
                "
                >{{ cinema.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
            <p class="error_message">{{ $t("blankfieldmsg") }}</p>
          </div>
          <div class="col-3" v-if="screenID == 0">
            <b-dropdown
              :text="dropDowns.screenDropdown.screenSelected.screen_name"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                v-for="(screen, screenIndex) in dropDowns.screenDropdown
                  .screens"
                href="#"
                :key="screenIndex"
                v-on:click="selectScreen(screen)"
                >{{ screen.screen_name }}</b-dropdown-item
              >
            </b-dropdown>
            <p class="error_message">{{ $t("blankfieldmsg") }}</p>
          </div>
          <div class="col-3">
            <div class="input-material">
              <input
              disabled
                placeholder="."
                @change="onChangeRowsColumns()"
                v-model="rows"
                type="number"
                required="required"
              />
              <label>Rows</label>
            </div>
          </div>
          <div class="col-3">
            <div class="input-material">
              <input
              disabled
                placeholder="."
                v-on:change="onChangeRowsColumns()"
                v-model="columns"
                type="number"
                required="required"
              />
              <label>columns</label>
            </div>
          </div>
        </div>
      </div>

      <header>
        <div class="row justify-content-between mx-0">
          <div
            v-for="(seatType, seatTypeIndex) in seatTypes"
            :key="seatTypeIndex"
            class="mx-1 mx-xl-3"
            v-on:click="selectSeatType(seatType)"
          >
            <div
            :class="seatTypeSelected == seatType && seatTypeSelectionMode == 'seatType' ? 'selected_seat_type_active' : ''"
            v-if="seatType.imageURL"
              class="cinema-seat my-0 mx-auto bg-blue"
            >
            <img :src="seatType.imageURL" height="28" width="27" />
            </div>
            <div
            v-else
            :class="seatTypeSelected == seatType && seatTypeSelectionMode == 'seatType' ? `selected_seat_type_active ${seatType.imageClass}` : `${seatType.imageClass}`"
              class="cinema-seat my-0 mx-auto bg-blue"
            >
            </div>
            <small>{{ seatType.seatName }}</small>
          </div>
        </div>

        <div class="d-flex align-items-center mt-3 mb-4 flex-wrap">
          <div
            class="mx-1"
            v-for="(screenSeatType, screenSeatTypeIndex) in screenSeatTypes"
            :key="'index' + screenSeatTypeIndex"
          >
            <b-button
              variant="default"
              class="btn-outline-blue"
              :class="screenSeatTypeSelected == screenSeatType && seatTypeSelectionMode == 'screenSeatType' ? 'selected_screen_type_active' : ''"
              v-on:click="selectScreenSeatType(screenSeatType)"
              :style="{
                borderColor:
                  screenSeatType && screenSeatType.sst_seat_color_code
                    ? screenSeatType.sst_seat_color_code
                    : '#000000',
                backgroundColor:
                  screenSeatType && screenSeatType.sst_seat_color_code
                    ? screenSeatType.sst_seat_color_code
                    : '#000000',
                color: 'white'
              }"
              >{{ screenSeatType.sst_seat_type }} -
              {{ screenSeatType.sst_no_of_seats }} seat(s)</b-button
            >
          </div>
          <div class="mx-1">
            <button
              v-on:click="showName = !showName"
              :class="showName ? 'btn-blue' : 'btn-outline-blue'"
            >
              Show Grid
            </button>
          </div>
          <div class="mx-1">
            <button
              v-on:click="onReverseOrder()"
              :class="showName ? 'btn-blue' : 'btn-outline-blue'"
            >
              Reverse Order
            </button>
          </div>
          <div class="mx-1">
            <button
              v-on:click="onReverseRow()"
              :class="showName ? 'btn-blue' : 'btn-outline-blue'"
            >
              Reverse Row
            </button>
          </div>
          <div class="mx-1">
            <div class="d-flex align-items-center">
              <label>{{ $t("show") }} {{ $t("row") }} {{ $t("name") }}</label>
              <label class="ios-switch ml-2">
                <input
                  type="checkbox"
                  class="ios-checkbox"
                  v-model="showRowNumber"
                />
                <span class="switch-slider"></span>
              </label>
            </div>
          </div>
        </div>
      </header>
      <div class="col-12">
        <div class="selected-option">
          <span class="fs-16 font-weight-bold">Selected Option:</span>&nbsp;
           {{seatTypeSelectionMode == 'screenSeatType'  && screenSeatTypeSelected ? screenSeatTypeSelected.sst_seat_type : seatTypeSelected ? seatTypeSelected.seatName : '' }}
        </div>
         <div class="selected-option" v-if="seatTypeSelectionMode == 'seatType'">
          <span class="fs-16 font-weight-bold">Capacity:</span>&nbsp;
           {{seatTypeSelected ? seatTypeSelected.size : 1 }}
        </div>
      </div>
      <div class="col-12" v-if="screenID != 0">
        <h5 class="text-center pt-3">All Eyes This Way</h5>
        <div
          class="cinema-seatlayout"
          onmousedown="vmVue.$emit('mouseKeyDown', 'test')"
          onmouseup="vmVue.$emit('mouseKeyUp', 'test')"
        >
          <table class="generateSeatLayout">
            
            <tr v-for="(row, rowIndex) in seats" :key="rowIndex">
              <!-- <tr v-for="(row, rowIndex) in parseInt(rows)" :key="rowIndex"> -->
              <td>
                <div class="cinema-seatName">{{ row.rowName }}</div>
                <input
                  v-if="showName"
                  type="text"
                  class="changeSeatName"
                  v-model="seats[rowIndex].rowName"
                  @change="changeRowName()"
                />
              </td>
              <td
                v-for="(column, columnIndex) in row.singleRow"
                :key="'singleSeat' + columnIndex + 1"
                colspan="1"
              >
                <!-- :colspan="seats[row][singleSeat].seatType == 'love-seat'? 2 : 1" -->
                <div
                  v-if="isReversedRow == false"
                  :class="showRowNumber || rowIndex == 0 ? '' : 'd-none'"
                  class="cinema-seatNumber"
                >
                  {{ columnIndex + 1 }}
                </div>
                <div
                  v-else
                  :class="showRowNumber || rowIndex == 0 ? '' : 'd-none'"
                  class="cinema-seatNumber"
                >
                  {{ row.singleRow.length - columnIndex }}
                </div>
                <div
                  v-if="
                    !showName &&
                      seats[rowIndex] &&
                      seats[rowIndex].singleRow[columnIndex]
                  "
                  @mousedown="mouseDownOnSeat(columnIndex, rowIndex)"
                  @mouseover="!checkMouseOver() ? mouseOverSeat(columnIndex, rowIndex) : null"
                  @click="checkMouseOver() ? mouseOverSeat(columnIndex, rowIndex) : null"
                  class="cinema-seat"
                  :class="seats[rowIndex].singleRow[columnIndex].seatType && seats[rowIndex].singleRow[columnIndex].seatType.imageURL ? 
                    '' : seats[rowIndex].singleRow[columnIndex].seatType && seats[rowIndex].singleRow[columnIndex].seatType.imageClass
                  "
                  :style="{
                    borderColor:
                      seats[rowIndex].singleRow[columnIndex].screenSeatType &&
                      seats[rowIndex].singleRow[columnIndex].screenSeatType
                        .sst_seat_color_code
                        ? seats[rowIndex].singleRow[columnIndex].screenSeatType
                            .sst_seat_color_code
                        : '#000000',
                    backgroundColor:
                      seats[rowIndex].singleRow[columnIndex].screenSeatType &&
                      seats[rowIndex].singleRow[columnIndex].screenSeatType
                        .sst_seat_color_code
                        ? seats[rowIndex].singleRow[columnIndex].screenSeatType
                            .sst_seat_color_code
                        : '#000000'
                  }"
                >
                <img v-if="seats[rowIndex].singleRow[columnIndex].seatType.imageURL" :src="seats[rowIndex].singleRow[columnIndex].seatType.imageURL" height="28" width="27" />
                </div>
                <!-- :style="{ borderColor: seats[rowIndex][columnIndex].screenSeatType.sst_seat_color_code, backgroundColor: seats[rowIndex][columnIndex].screenSeatType.sst_seat_color_code}" -->

                <input
                  v-if="showName"
                  type="text"
                  class="changeSeatName"
                  v-model="seats[rowIndex].singleRow[columnIndex].seatName"
                />
                <!-- {{seats[rowIndex][columnIndex]}} -->
                <!-- :class="seats[row][column].seatTypeImageClass" -->

                <!-- v-bind:class="{ 'vip-seat': singleSeat.seatTypeImageClass, 'normal-seat': singleSeat.seatTypeImageClass }" -->
              </td>

              <td>
                <div class="cinema-seatName">{{ row.rowName }}</div>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div v-if="screenID != 0" class="col-12 py-2 text-center">
        <b-button
          :disabled="btenable"
          variant="default"
          class="btn-blue"
          v-on:click="submitSeatLayout()"
          >{{ $t("save") }}</b-button
        >
        <b-button
          variant="default"
          @click="onResetSeatLayout()"
          class="btn-black"
          >{{ $t("reset") }}</b-button
        >
        <b-button
          class="btn-outline-grey"
          variant="default"
          to="/cinema-manager/seat-layout"
          >{{ $t("cancel") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

var thing = {
  data() {
    return {
      btenable: false,
      showRowNumber: true,
      dropDowns: {
        cinemaDropdown: {
          cinemas: [],
          cinemaSelected: {
            cine_name: "Select Cinema"
          }
        },
        screenDropdown: {
          screens: [],
          screenSelected: {
            screen_name: "Select Screen"
          }
        }
      },
      screenSeatTypes: [],
      showName: false,
      seatTypeSelected: {
        seatName: "Normal Seat",
        size: 1,
        value: 1,
        imageClass: "regular-seat"
      },
      screenSeatTypeSelected: {},
      seatTypeSelectionMode: "seatType",
      mouseDownStatus: false,
      initialSeatValueSelected: {
        row: 0,
        column: 0
      },
      finalSeatValueSelected: {
        row: 0,
        column: 0
      },
      screenName: null,
      seatTypes: [
        {
          seatName: "Regular Seat",
          size: 1,
          value: 1,
          imageClass: "regular-seat",
          imageURL: ''
        },
        {
          seatName: "No Seat",
          size: 1,
          value: 2,
          imageClass: "no-seat",
          imageURL: ''
        },
        {
          seatName: "Wheel Chair",
          size: 1,
          value: 3,
          imageClass: "wheelchair",
          imageURL: ''
        },
        {
          seatName: "VIP Seat",
          size: 1,
          value: 5,
          imageClass: "vip-seat",
          imageURL: ''
        },
        // {
        //   seatName: "Couple Seats",
        //   size: 6,
        //   imageClass: "love-seat",
        // },
        {
          seatName: "Only POS",
          size: 1,
          value: 9,
          imageClass: "pointofsale",
          imageURL: ''
        },
        {
          seatName: "Sofa",
          size: 1,
          value: 10,
          imageClass: "sofa-seat",
          imageURL: ''
        },
        {
          seatName: "Recliner",
          size: 1,
          value: 11,
          imageClass: "recliner",
          imageURL: ''
        }
        // {
        //   seatName: "Blocked Seat",
        //   size: 1,
        //   value: 12,
        //   imageClass: "block-seat",
        // },
      ],
      seatTypes1: [],
      rows: 10,
      columns: 10,
      seats: [],
      seatsCopy: [],
      screenID: 0,
      isReversedRow: false,
      isReversedRowName: false,
      isReversed: true,
      activeSeatTypes: []
      // "vipSeat", "regularSeat", "NoSeat", "WheelChair"],
    };
  },
  beforeMount() {
    if (!this.$route.params.screenID) {
      this.getCinemas();
      this.getScreens();
    } else {
      this.screenID = this.$route.params.screenID;
      // this.getScreenSeatType();
    }
    this.getSeatTypes();
  },
  mounted() {
    this.getScreenDetails();
    this.getScreenSeatType();
    vmVue.$on("mouseKeyDown", this.mouseDown);
    vmVue.$on("mouseKeyUp", this.mouseUp);
  },
  methods: {
    checkMouseOver() {
      if(this.seatTypeSelected && this.seatTypeSelected.hasOwnProperty('size') && this.seatTypeSelected.size > 1) {
        return true;
      } else {
        return false;
      }
    },
      getSeatTypes: function(screen) {
      let payload = {
        tableName: "ms_seat_reserve_types",
        srt_is_active: "Y"
      };
      this.seatTypes = [];
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.activeSeatTypes = data.Records;
            this.activeSeatTypes.map((x) => {
              let obj = {
                seatName: x.srt_name,
                size: x.srt_seat_capacity,
                value: x.srt_id,
                imageClass: "regular-seat",
                imageURL: this._GetImagePath(x.srt_dash_image_url)
              }
              if(x.srt_id == 1) {
                this.seatTypeSelected = obj
              }
              this.seatTypes.push(obj)
            })
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch Error :", error);
        });
    },
    onResetSeatLayout: function() {
      this.seats = [];
      this.seats = this.seatsCopy;
    },
    onReverseOrder: function() {
      console.log(this.seats);
      if (this.isReversedRowName) {
        this.seats.sort(function(a, b) {
          return b.rowName.localeCompare(a.rowName);
        });
      } else {
        this.seats.sort(function(a, b) {
          return a.rowName.localeCompare(b.rowName);
        });
      }
      this.isReversedRowName = !this.isReversedRowName;
    },
    onReverseRow: function() {
      if (!this.isReversedRow) {
        let newSeats = this.seats;
        this.seats = [];

        for (let i = 0; i < newSeats.length; i++) {
          let seatRow = [];
          let z = 0;
          let emptySeatsInRow = 0;
          let availableSeats = 0;
          for (let j = 0; j < newSeats[0].singleRow.length; j++) {
           
            let singleSeat = newSeats[i].singleRow[j];
            if (this.seatTypeSelectionMode == "screenSeatType") {
              if (newSeats[i].singleRow[j].seatType.value == 2) {
                emptySeatsInRow++;
              } else {
                availableSeats++;
              }
            } else {
              if (singleSeat.seatType.value == 2) {
                emptySeatsInRow++;
              } else {
                availableSeats++;
              }
            }
           
          }

          console.log({ emptySeatsInRow, availableSeats });
          z = availableSeats;

          for (let j = 0; j < newSeats[0].singleRow.length; j++) {
            console.log("row=", i, "column", j, seatRow);
            //Do math to select between final and initial row && final and initial column
            console.log("singleSeat :", singleSeat);
            let singleSeat = newSeats[i].singleRow[j];
            if (this.seatTypeSelectionMode == "screenSeatType") {
              if (newSeats[i].singleRow[j].seatType.value == 2) {
                singleSeat.seatName = "";
              } else {
                singleSeat.seatName = newSeats[i].rowName + parseInt(z);
                z--;
              }
            } else {
              if (singleSeat.seatType.value == 2) {
                singleSeat.seatName = "";
              } else {
                singleSeat.seatName = newSeats[i].rowName + parseInt(z);
                z--;
              }
            }
            console.log("singleSeat :", singleSeat);
            seatRow.push(singleSeat);
            // console.log(this.seats, seatRow);
          }
          this.seats.push({
            rowName: newSeats[i].rowName,
            singleRow: seatRow
          });
        }
      } else {
        let newSeats = this.seats;
        this.seats = [];

        for (let i = 0; i < newSeats.length; i++) {
          let seatRow = [];
          let z = 0;
          for (let j = 0; j < newSeats[0].singleRow.length; j++) {
            console.log("row=", i, "column", j, seatRow);
            //Do math to select between final and initial row && final and initial column
            console.log("singleSeat :", singleSeat);
            let singleSeat = newSeats[i].singleRow[j];
            if (this.seatTypeSelectionMode == "screenSeatType") {
              if (newSeats[i].singleRow[j].seatType.value == 2) {
                singleSeat.seatName = "";
              } else {
                singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                z++;
              }
            } else {
              if (singleSeat.seatType.value == 2) {
                singleSeat.seatName = "";
              } else {
                singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                z++;
              }
            }
            console.log("singleSeat :", singleSeat);
            seatRow.push(singleSeat);
            // console.log(this.seats, seatRow);
          }
          this.seats.push({
            rowName: newSeats[i].rowName,
            singleRow: seatRow
          });
        }
      }
      this.isReversedRow = !this.isReversedRow;
    },
    changeRowName: function() {
      
      let newSeats = this.seats;
      this.seats = [];
    
      for (let i = 0; i < newSeats.length; i++) {
        let seatRow = [];
        let z = 0;
        let emptyColumn = 0;
        for (let j = 0; j < newSeats[i].singleRow.length; j++) {
          let singleSeat = newSeats[i].singleRow[j];

          if (singleSeat.seatType.value == 2) {
            singleSeat.seatName = "";
          } else {
            singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
            z++;
          }

          seatRow.push(singleSeat);
        }

        this.seats.push({
          rowName: newSeats[i].rowName,
          singleRow: seatRow
        });
        this.seatsCopy.push({
          rowName: newSeats[i].rowName,
          singleRow: seatRow
        });
      }
    },
    getScreenDetails: function() {
      let payload = {
        tableName: "screens",
        // screen_is_active: "Y", // // Get cinema_id when user will login // if cinema_id is null he can't access this page.
        screen_id: this.screenID
      };
      console.log("coming", payload);
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.posOperations = data.Records;
            this.screenName = data.Records[0].screen_name;
            this.rows = data.Records[0].screen_no_of_rows;
            this.columns = data.Records[0].screen_no_of_cols;
            //getseatreservetype

            this.onChangeRowsColumns();
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    getScreenSeatType: function() {
      let payload = {
        tableName: "screen_seat_type",
        sst_is_active: "Y", // // Get cinema_id when user will login // if cinema_id is null he can't access this page.
        screen_id: this.screenID
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.posOperations = data.Records;
            this.screenSeatTypes = data.Records;
            //getseatreservetype

            this.onChangeRowsColumns();
          } else if (data.Records.length == 0) {
            // Show Error Message:
            this.$toasted.show(
              "No active seat types found for this screen.Please add atleast one seat types"
            );
            this.$router.go(-1);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    submitSeatLayout: function() {
      // console.log("test");
      let allSeats = [];
      let count = 0;
      let that = {
        seats: this.seats
      };
      console.log(this.seats, "fdsfdsf");

      for (let i = 0; i < this.seats.length; i++) {
        for (let j = 0; j < this.seats[0].singleRow.length; j++) {
          if (this.seats[i].singleRow[j].screenSeatType.sst_id == 0) {
            console.log(this.seats[i].singleRow[j].screenSeatType.sst_id, i, j);
            count++;
          }
          allSeats.push({
            sl_row_num: i + 1,
            sl_seat_name: that.seats[i].singleRow[j].seatName,
            sl_col_num: j + 1,
            screen_seat_type_id:
              that.seats[i].singleRow[j]["screenSeatType"].sst_id, // seats[i][j].seatType.seatTypeID
            sl_seat_status: "0",
            sl_group_id: that.seats[i].singleRow[j].groupId || null,
            seat_reserve_type_id: that.seats[i].singleRow[j]["seatType"].value
            // seatType: this.seatTypeSelected,
            // seatTypeImageClass: this.seatTypeSelected.imageClass,
            // seatName: newSeats[i][j].seatName,
            // anyOtherData: "test"
          });
        }
      }

      // console.log("allSeats TEST IMPORTANT", allSeats);
      // return false;

      setTimeout(() => {
        console.log(count);
        if (count > 0) {
          this.$toasted.show("Please Complete remaining " + count + "seat");
          return;
        }
        this.btenable = true;

        let payload = {
          screen_layout: allSeats,
          // screen_layout: [
          //   {
          //     sl_row_num: 1,
          //     sl_seat_name: "",
          //     sl_col_num: 1,
          //     screen_seat_type_id: 643,
          //     sl_seat_status: "0",
          //     seat_reserve_type_id: 1
          //   },
          //   {
          //     sl_row_num: 1,
          //     sl_seat_name: "",
          //     sl_col_num: 2,
          //     screen_seat_type_id: 643,
          //     sl_seat_status: "0",
          //     seat_reserve_type_id: 1
          //   }
          // ],
          screen_id: this.screenID,
          sl_row_num_tot: this.rows,
          sl_col_num_tot: this.columns
        };
        console.log("JSON.stringyfy() :", JSON.stringify(payload));
        MasterService.addScreenLayout(payload)
          .then(response => {
            this.btenable = false;
            const { data } = response;
            console.log(response);
            if (!data.error) {
              this.$router.go(-1);
            } else {
            }
          })
          .catch(error => {
            this.showMessageSnackbar("Error in getReportListData ", error);
          });
      }, 100);
    },
    getCinemas: function() {
      MasterService.getCinemaList()
        .then(response => {
          const { data } = response;
          console.log(response);
          if (!data.error) {
            this.dropDowns.cinemaDropdown.cinemas = data.data;
          } else {
          }
        })
        .catch(error => {
          this.showMessageSnackbar("Error in getReportListData ", error);
        });
    },
    getScreens: function() {
      MasterService.getScreenList()
        .then(response => {
          const { data } = response;
          console.log(response);
          if (!data.error) {
            this.dropDowns.screenDropdown.screens = data.data;
          } else {
          }
        })
        .catch(error => {
          this.showMessageSnackbar("Error in getReportListData ", error);
        });
    },
    onChangeRowsColumns: function() {
      // this.isReversedRow = false;
      // this.isReversedRowName = false;
      console.log("test");
      this.seats = [];
      var seatRow = [];
      this.seatsCopy = [];
      for (let i = 0; i < this.rows; i++) {
        seatRow = {
          singleRow: [],
          rowName: String.fromCharCode(i + 65)
        };
        for (let j = 0; j < this.columns; j++) {
          let screenSeatType = {
            sst_id: 0,
            sst_seat_color_code: "#000000"
          };
          seatRow.singleRow.push({
            screenSeatType: screenSeatType, //this.screenSeatTypes[0],
            seatType: this.seatTypes.find((x) => {
              if(x.value == 1) {
                return {...x, seatName: x.srt_name, size: x.srt_seat_capacity, value: x.srt_id, imageClass: "regular-seat", imageURL: x.srt_dash_image_url }
              }
            }),
            // seatType: {
            //   seatName: "regularSeat",
            //   size: 1,
            //   value: 1,
            //   imageClass: "regular-seat",
            //   imageURL: ""
            // },
            seatTypeImageClass: "normal-seat",
            seatName: seatRow.rowName + parseInt(j + 1),
            anyOtherData: "test"
          });
        }
        this.seats.push(seatRow);
        this.seatsCopy.push(seatRow);
        console.log("this.seatdwvwtrfyewiuhe872t872y92uw92w9s,", this.seats);
      }
      // console.log(this.seats, seatRow);

      // for (let i = 0; i++; i < this.rows) {
      //   for (let j = 0; j++; j < this.columns) {
      //     seats[i][j] = {
      //       seatType: "normal",
      //       anyOtherData: "test"
      //     };
      //   }
      // }
    },
    selectScreen: function(screen) {
      console.log("screen :", screen);
      this.dropDowns.screenDropdown.screenSelected = screen;

      // for (let x in screen.screen_seat_type) {
      //   x.sst_seat_color_code = "orange";
      //   console.log(x);
      //   this.screenSeatType.push(x);
      // }
      //  = screen.screen_seat_type;

      this.screenSeatTypes = screen.screen_seat_type;
      this.screenID = screen.screen_id;
    },
    selectSeatType: function(seatType) {
      console.log(seatType);
      this.seatTypeSelected = seatType;
      this.seatTypeSelectionMode = "seatType";
    },
    selectScreenSeatType: function(seatScreenType) {
      console.log(seatScreenType);
      this.screenSeatTypeSelected = seatScreenType;
      this.seatTypeSelectionMode = "screenSeatType";
    },
    mouseDown: function() {
      this.mouseDownStatus = true;

      // this.mouseOverSeat(seatColumnSelected, seatRowSelected, true);
    },
    mouseUp: function() {
      this.mouseDownStatus = false;
      var count = 0;
      for (let i = 0; i < this.seats.length; i++) {
        for (let j = 0; j < this.seats[i].singleRow.length; j++) {
          if (
            this.seats[i].singleRow[j].screenSeatType.sst_id ==
              this.screenSeatTypeSelected.sst_id &&
            this.seats[i].singleRow[j].seatType.value != 2
          ) {
            count++;
          }
          if (count > this.screenSeatTypeSelected.sst_no_of_seats) {
            this.$toasted.show(
              "Maximum seats for " +
                this.screenSeatTypeSelected.sst_seat_type +
                " can be " +
                this.screenSeatTypeSelected.sst_no_of_seats
            );
            for (let k = j; k < this.seats[i].singleRow.length; k++) {
              let screenSeatType = {
                sst_id: 0,
                sst_seat_color_code: "#000000"
              };
              this.seats[i].singleRow[k].screenSeatType = screenSeatType; // this.screenSeatTypes[0];
            }
            break;
          }
        }
      }
    },
    mouseDownOnSeat: function(seatColumnSelected, seatRowSelected) {
      this.initialSeatValueSelected.column = seatColumnSelected;
      this.initialSeatValueSelected.row = seatRowSelected;
      this.mouseOverSeat(seatColumnSelected, seatRowSelected, true);
    },
    mouseOverSeat: function(seatColumnSelected, seatRowSelected, clickStatus, onlyWorkonClick = false) {     
      if (!clickStatus) {
        this.finalSeatValueSelected.column = seatColumnSelected;
        this.finalSeatValueSelected.row = seatRowSelected;
      }
      if (this.mouseDownStatus || clickStatus == true) {
        let newSeats = this.seats;
        this.seats = [];
        let checkIndexArray = [];
        let groupSeatsIndexes = [];
        for (let i = 0; i < newSeats.length; i++) {
          let seatRow = [];
          let z = 0;
          var count = 0;
          let qty =  1;
          let errorCount = 0;
          
          if (this.seatTypeSelected && this.seatTypeSelected.hasOwnProperty('size')) {
            qty = this.seatTypeSelected.size
          }
          
          if(i == seatRowSelected && this.seatTypeSelectionMode != "screenSeatType") {
          for(let check=seatColumnSelected; check < seatColumnSelected + qty; check++ ) {
                  if(newSeats[i].singleRow[check] && newSeats[i].singleRow[check].seatType.value == 1) {
                    let groupObj = {
                      index: check,
                      row: i,
                      col:check,
                      seatName: newSeats[i].singleRow[check].seatName,
                      groupId: `${seatColumnSelected + 1}_${seatRowSelected + 1}_${newSeats[i].singleRow[seatColumnSelected].seatName}`
                    }
                    // checkIndexArray.push(check);
                    checkIndexArray.push(groupObj);
                  } else {
                    errorCount++;
                    checkIndexArray = [];
                  }
                }

                if(errorCount > 0) {
                  errorCount = 0;
                  checkIndexArray =[];
                  for(let check=seatColumnSelected; check > seatColumnSelected - qty; check-- ) {
                  if(newSeats[i].singleRow[check] && newSeats[i].singleRow[check].seatType.value == 1) {
                    let groupObj = {
                      index: check,
                      row: i,
                      col:check,
                      seatName: newSeats[i].singleRow[check].seatName,
                      groupId: `${seatColumnSelected + 1}_${seatRowSelected + 1}_${newSeats[i].singleRow[seatColumnSelected].seatName}`
                    }
                    // checkIndexArray.push(check);
                    checkIndexArray.push(groupObj);
                  } else {
                    errorCount++;
                    checkIndexArray = [];
                  }
                }
                }   
                
                let clickedSeat = newSeats[seatRowSelected].singleRow[seatColumnSelected];
                  if(clickedSeat && (clickedSeat.seatType.value == this.seatTypeSelected.value || this.seatTypeSelected.value == 1) ) {
                    if(clickedSeat.hasOwnProperty('groupId') && clickedSeat.groupId) {
                      groupSeatsIndexes = newSeats[i].singleRow.reduce(function(a, e, i) {
                          if (e.groupId == clickedSeat.groupId)
                              a.push(i);
                          return a;
                      }, []);
                      console.log('groupSeatsIndexes', groupSeatsIndexes);
                    }

                    if(groupSeatsIndexes.length > 0) {
                      checkIndexArray = [];
                      errorCount = 0
                    }
                  }
                }

                if(errorCount > 0) {
                  this.$toasted.show('No Space')
                  checkIndexArray = [];
                }
                
                console.log('checkIndexArray', checkIndexArray);


          for (let j = 0; j < newSeats[0].singleRow.length; j++) {
            //Do math to select between final and initial row && final and initial column
            if (seatRowSelected == i && seatColumnSelected == j) {
              if (this.seatTypeSelectionMode == "screenSeatType") {
                // console.log(
                //   "object :",
                //   newSeats[i][j],
                //   this.screenSeatTypeSelected
                // );
                let singleSeat = {
                  seatType: newSeats[i].singleRow[j].seatType, //normal, wheelchair, empty
                  screenSeatType: this.screenSeatTypeSelected,
                  seatTypeImageClass: this.seatTypeSelected.imageClass,
                  seatName: newSeats[i].singleRow[j].seatName,
                  anyOtherData: "test1"
                };
                if (newSeats[i].singleRow[j].seatType.value == 2) {
                  singleSeat.seatName = "";
                }
                //  else {
                //   singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                //   z++;
                // }

                seatRow.push(singleSeat);

                //create
              } else if(seatRowSelected == i && groupSeatsIndexes.length > 0 && groupSeatsIndexes.includes(j)) {
                let singleSeat = {
                  seatType: this.seatTypes.find((x) => x.value == 1),
                  screenSeatType: newSeats[i].singleRow[j].screenSeatType,
                  seatTypeImageClass: this.seatTypeSelected.imageClass,
                  seatName: newSeats[i].singleRow[j].seatName,
                  anyOtherData: "test2",
                  groupId: null
                };

                if (this.seatTypeSelected.value == 2) {
                  singleSeat.seatName = "";
                }

                 seatRow.push(singleSeat);
              } else {
                let groupDetails = checkIndexArray.find((c) => c.col == j);
                // console.log("object1 :", newSeats[i][j]);
                let singleSeat = {
                  seatType: this.seatTypeSelected, //normal, wheelchair, empty
                  screenSeatType: newSeats[i].singleRow[j].screenSeatType,
                  seatTypeImageClass: this.seatTypeSelected.imageClass,
                  seatName: newSeats[i].singleRow[j].seatName,
                  anyOtherData: "test2",
                  groupId: groupDetails ? groupDetails.groupId : null
                };
                if (this.seatTypeSelected.value == 2) {
                  singleSeat.seatName = "";
                }

                // } else {
                //   singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                //   z++;
                // }
                if(errorCount > 0) {
                   let singleSeatTemp = newSeats[i].singleRow[j];
                  if(!singleSeatTemp.hasOwnProperty('groupId')) {
                    singleSeatTemp["groupId"] = null;
                  }
                  seatRow.push(singleSeatTemp)
                } else {
                   seatRow.push(singleSeat);
                }
              }
            } else if(seatRowSelected == i && groupSeatsIndexes.length > 0 && groupSeatsIndexes.includes(j)) {
               let singleSeat = {
                  seatType: this.seatTypes.find((x) => x.value == 1),
                  screenSeatType: newSeats[i].singleRow[j].screenSeatType,
                  seatTypeImageClass: this.seatTypeSelected.imageClass,
                  seatName: newSeats[i].singleRow[j].seatName,
                  anyOtherData: "test2",
                  groupId: null
                };

                if (this.seatTypeSelected.value == 2) {
                  singleSeat.seatName = "";
                }

                 seatRow.push(singleSeat);
            } else if(seatRowSelected == i && checkIndexArray.length > 0 && checkIndexArray.some((z) => z.col == j)) {
              let groupDetails = checkIndexArray.find((c) => c.col == j);
               let singleSeat = {
                  seatType: this.seatTypeSelected, //normal, wheelchair, empty
                  screenSeatType: newSeats[i].singleRow[j].screenSeatType,
                  seatTypeImageClass: this.seatTypeSelected.imageClass,
                  seatName: newSeats[i].singleRow[j].seatName,
                  anyOtherData: "test2",
                  groupId: groupDetails ? groupDetails.groupId : null
                };

                if (this.seatTypeSelected.value == 2) {
                  singleSeat.seatName = "";
                }

                 seatRow.push(singleSeat);
            } else {
              let singleSeat = newSeats[i].singleRow[j];
              if(!singleSeat.hasOwnProperty('groupId')) {
                singleSeat["groupId"] = null;
              }
              if (this.seatTypeSelectionMode == "screenSeatType") {
                if (newSeats[i].singleRow[j].seatType.value == 2) {
                  singleSeat.seatName = "";
                }
                //  else {
                //   singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                //   z++;
                // }
              } else {
                if (singleSeat.seatType.value == 2) {
                  singleSeat.seatName = "";
                }

                //  else {
                //   singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                //   z++;
                // }
              }

              seatRow.push(singleSeat);
            }
            // console.log(this.seats, seatRow);
          }

          this.seats.push({
            rowName: newSeats[i].rowName,
            singleRow: seatRow
          });
        }
        // this.$set(this.items, indexOfItem, newValue)
        // if (this.seatTypeSelected.value == 2) {
        //   this.changeRowName(true);
        // }
      }
    }
  }
};
global.thing = thing;
export default thing;
</script>

<style>
.selected_seat_type_active {
 box-shadow: 0px 2px 5px 1px #e41c1c
}
.selected_screen_type_active {
 box-shadow: 0px 2px 5px 1px #e41c1c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemaSeatLayoutComponents/addSeatLayout.vue